import React, { Component,useState,useEffect } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Grid from '../../components/grid/grid'
import {data_insight} from '../../dummy/data'
import HeadPage from '../../components/header'
import {getInsight,getTopic,setFilter} from '../../redux/action/insight'
import {connect} from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import {Button,Checkbox,FormGroup ,Radio,RadioGroup,FormControlLabel,FormControl,FormLabel,TextField,InputAdornment} from '@material-ui/core'
import Search from '../../assets/image/Search.png'
import { MuiThemeProvider, createMuiTheme, makeStyles} from '@material-ui/core/styles'
import {useSelector,useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
const themeButton = createMuiTheme({ 
    palette: { 
        secondary: {
            main:'#00a1ed',
            contrastText: '#FFFFFF',

        },
        primary: {
            main:'#00a1ed',
            contrastText: '#FFFFFF',

        },
    } 
})
const useStyles = makeStyles(theme => ({
   
  search: {
    [`& fieldset`]: {
        borderRadius: 8,
        height:40,
        margin: theme.spacing(1),
      },
      width:'100%',
      height:20,
      marginBottom:40
    },
    input:{
        fontSize:16,
        margin:'6px 0px 5px 0px'
      }
}));
export default function Index() {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const insight = useSelector(state => state.insight)
    const [listinsight, setlistinsight] = useState([])
    const [filter, setfilter] = useState(false)
    const [topic, settopic] = useState({
        all:true,
        Strategy:false,
        Process:false,
        Performance:false,
        People:false,
        Culture:false
    })
    useEffect( () => {
        if(isEmpty(insight.list_insight)){
            getListInsight()
        }else{
            let arr=Object.keys(topic).map((key) => [key, topic[key]]);
            let new_topic=[]
            arr.map((data)=>{
                if(data[1]){
                    new_topic.push(data[0])
                }
            })
    
            
            if(new_topic[0]==='all'){
                setlistinsight(insight.list_insight)
            }else{
                let filter_insight=[]
                insight.list_insight.map((data)=>{
                    let check=new_topic.includes(data.categories[0].text)
                    if(check){
                        filter_insight.push(data)
                    }
                })
                setlistinsight(filter_insight)
            }
    
    
        }
    }, [topic])
    const getListInsight=async ()=>{
        let res=await dispatch(getInsight(`/${200}`))
        if(res){
            setlistinsight(res.data)
        }
    }
    const filterToggle=()=>{
        setfilter(!filter)
    }
    const loader=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
            </div>
        )
    }
    const onChange=(e)=>{
        let {name,checked}=e.target
        
        settopic({...topic,[name]: checked,all:false})
    }
    const onChangeAll=(e)=>{
        settopic({
            all:true,
        Strategy:false,
        Process:false,
        Performance:false,
        People:false,
        Culture:false
        })
        

    }
    const renderTopic=()=>{
        let arr=Object.keys(topic).map((key) => [key, topic[key]]);
        let new_topic=[]
        arr.map((data)=>{
            if(data[1]){
                new_topic.push(data[0])
            }
        })

        
        
        return(
            <h4 style={{color:'#00a1ed',cursor:'pointer'}} onClick={filterToggle}>{new_topic[0]==='all'?'All topic':new_topic.join(' , ')}</h4>
        )
    }
    const searchToggle=(value)=>{
        if(value.length>0){
            let filter=insight.list_insight.filter((data)=>{
                return data.title.toLowerCase().includes(value.toLowerCase())
            })
            setlistinsight(filter)
        }else{
            setlistinsight(insight.list_insight)
        }
        
    }
    const classes=useStyles()
    return (
        <div>
            <Navbar/>
            <br/><br/><br/><br/><br/>
            {filter&&<div onClick={filterToggle} className='insight-filter-backdoor'></div>}
            <section className='event-page'>
                <HeadPage title='Insight' subtitle='Check out our latest thinking' is_filter={false}/>
                <div className='filter-head div-flex div-justify-between div-align-center'>
                    <div className='filter'>
                        <h4 style={{color:'#464646'}}>Browse by</h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {renderTopic()}
                    </div>
                    <div className='filter-search'>
                    <TextField
                        placeholder="Search our insight here"
                        variant='outlined'
                        size='small'
                        inputProps={{
                            className:classes.input
                        }}
                        InputLabelProps={{shrink: false}}
                        className={classes.search}
                        onChange={(e)=>searchToggle(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                <img alt="search" src={Search} style={{width:15,marginLeft:8}}/>
                            </InputAdornment>
                            ),
                        }}
                    />
                    </div>
                </div>
                
                {filter&&<div className='insight-filter'>
                    <p><b>Sort by topic</b></p>
                    <MuiThemeProvider theme={themeButton}>
                    <FormControl component="fieldset" >
                        <FormGroup >
                            <FormControlLabel
                                checked={topic.all} 
                                onChange={(e)=>onChangeAll(e)}
                                control={<Checkbox  name='all' size='small'/>}
                                label="All topic"
                            />
                            <FormControlLabel
                                checked={topic.Strategy} 
                                onChange={(e)=>onChange(e)}
                                control={<Checkbox  name="Strategy" size='small'/>}
                                label="Strategy"
                            />
                            <FormControlLabel
                                checked={topic.Process} 
                                onChange={(e)=>onChange(e)}
                                control={<Checkbox  name="Process" size='small'/>}
                                label="Process"
                            />
                            <FormControlLabel
                                checked={topic.Performance} 
                                onChange={(e)=>onChange(e)}
                                control={<Checkbox  name="Performance" size='small'/>}
                                label="Performance"
                            />
                            <FormControlLabel
                                checked={topic.People} 
                                onChange={(e)=>onChange(e)}
                                control={<Checkbox  name="People" size='small'/>}
                                label="People"
                            />
                            <FormControlLabel
                                checked={topic.Culture} 
                                onChange={(e)=>onChange(e)}
                                control={<Checkbox  name="Culture" size='small'/>}
                                label="Culture"
                            />
                            
                        </FormGroup>
                    </FormControl>
                    </MuiThemeProvider>
                </div>}
                <br/>
                {general.isLoading?loader():<Grid data={listinsight}/>}
            </section>
            <br/>
            <Footer/>
        </div>
    )
}
